import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CopyButton.styles';
import { CopyIcon, SuccessFilledIcon } from '@/components/UI/Icons/Icons';
import { useToastStore } from '@/store/useToastStore';

type CopyButtonProps = {
  value?: string | number | null;
  successText?: string;
  className?: string;
};

export function CopyButton({ value, successText, className }: CopyButtonProps) {
  const { t } = useTranslation();
  const openToast = useToastStore(state => state.openToast);
  const copyText = value?.toString();

  async function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    event.stopPropagation();

    if (!copyText) return;

    try {
      await navigator.clipboard.writeText(copyText);
    } catch {
      return;
    }

    openToast({
      text: successText ?? t('common.copied'),
      icon: <SuccessFilledIcon width={20} height={20} />,
      size: 'compact',
      borderRadius: 14,
    });
  }

  return (
    <S.Root className={className}>
      <S.Tooltip
        content={t('common.copy')}
        placement="bottom"
        offset={8}
        allowedTriggers={['hover']}
        disabled={!copyText}
      >
        <S.Button
          type="button"
          onClick={handleClick}
          disabled={!copyText}
          aria-label={t('common.copy')}
        >
          <CopyIcon />
        </S.Button>
      </S.Tooltip>
    </S.Root>
  );
}
